import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { InstallationVendorForm, InstallationVendorFormType, buildInstallationVendorFormData } from './InstallationVendorForm'
import { getInstallationVendorById, updateInstallationVendor } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useParams } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Installation Vendors',
    path: '/system/installation-vendors'
  },
  {
    label: 'Edit',
    isCurrentPage: true
  }
]

export const EditInstallationVendor = () => {
  const { vendorId } = useParams()
  const { createToast } = useAppContext()
  const [vendor, setVendor] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const row = await getInstallationVendorById(vendorId)
        setVendor(row)
      } catch (err) {
        createToast('error', 'Error', err.response.data)
      }
    }
    load()
  }, [])

  const handleEdit = async (form) => {
    setIsSubmitting(true)

    try {
      const row = await updateInstallationVendor(vendorId, buildInstallationVendorFormData(form))
      if (row) {
        setVendor(row)
        createToast('success', 'Installation vendor updated.')
      } else {
        createToast('error', 'Failed to update.')
      }
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Edit Installation Vendor</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <InstallationVendorForm
              type={InstallationVendorFormType.Edit}
              onSubmit={handleEdit}
              isSubmitting={isSubmitting}
              initialForm={vendor}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
